import AWS from 'aws-sdk';

const handleAmazonConnectChatTransfer = async (contactCenterConfig, customerName = "Customer", additionalAttributes = {}, flowId_param = null) => {
  const {
    instanceId,
    // flowId, //Avoiding Const variable issues
    apiGatewayEndpoint,
    contactAttributes,
  } = contactCenterConfig;

  var {
    flowId
  } = contactCenterConfig;

  if (flowId_param != null) {
    flowId = flowId_param;
  };

  // Validate configuration
  if (!apiGatewayEndpoint || !instanceId || !flowId) {
    console.error('Amazon Connect chat configuration is incomplete.', { apiGatewayEndpoint, instanceId, flowId });
    return;
  }

  try {
    // Merge existing contactAttributes with additionalAttributes
    const mergedAttributes = {
      ...(contactAttributes || {}),
      ...additionalAttributes,
    };

    // Make API Gateway call
    const response = await fetch(apiGatewayEndpoint.startChatContact, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        instanceId,
        flowId,
        customerName: customerName || 'Customer',
        contactAttributes: mergedAttributes, // Use merged attributes
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to start chat contact: ${response.statusText}`);
    }

    const responseData = await response.json();
    console.log('Amazon Connect chat started successfully:', responseData);
    return responseData;
  } catch (error) {
    console.error('Error invoking API Gateway:', error);
  }
};

const handleAmazonConnectEmailContact = async (contactCenterConfig, customerName, emailAddress, subject, messageContent, attributes) => {
  const { instanceId, apiGatewayEndpoint } = contactCenterConfig;

  if (!apiGatewayEndpoint?.startEmailContact || !instanceId || !emailAddress || !subject || !messageContent) {
    console.error('Amazon Connect email configuration is incomplete.', { apiGatewayEndpoint, instanceId, emailAddress, subject, messageContent });
    return;
  }

  try {
    // Make API Gateway call
    const response = await fetch(apiGatewayEndpoint.startEmailContact, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        instanceId,
        fromEmailAddress: {
          EmailAddress: emailAddress,
          DisplayName: customerName || 'Customer'
        },
        destinationEmailAddress: contactCenterConfig.destinationEmailAddress,
        description: `Email from ${customerName}`,
        emailMessage: {
          MessageSourceType: "RAW",
          RawMessage: {
            Subject: subject,
            Body: messageContent,
            ContentType: "text/plain"
          }
        },
        attributes: attributes
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to start email contact: ${response.statusText}`);
    }

    const responseData = await response.json();
    console.log('Amazon Connect email started successfully:', responseData);
    return responseData;
  } catch (error) {
    console.error('Error invoking API Gateway:', error);
  }
};

// Search for customer profile using phone number
const handleAmazonConnectSearchProfile = async (contactCenterConfig, phoneNumber) => {
  const { apiGatewayEndpoint } = contactCenterConfig;

  if (!apiGatewayEndpoint?.searchProfiles || !phoneNumber) {
    console.error("Amazon Connect search profile configuration is incomplete.", {
      apiGatewayEndpoint,
      phoneNumber
    });
    return;
  }

  try {
    const response = await fetch(apiGatewayEndpoint.searchProfiles, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ phoneNumber }),
    });

    if (!response.ok) {
      throw new Error(`Failed to search profile: ${response.statusText}`);
    }

    const responseData = await response.json();
    console.log("Amazon Connect profile search successful:", responseData);
    return responseData;
  } catch (error) {
    console.error("Error searching for customer profile:", error);
  }
};

// Create a case in Amazon Connect Cases
const handleAmazonConnectCaseCreation = async (contactCenterConfig, customerId, title, summary, caseReason, attributes) => {
  const { apiGatewayEndpoint } = contactCenterConfig;

  if (!apiGatewayEndpoint?.createCase || !customerId || !title || !summary || !caseReason) {
    console.error("Amazon Connect case creation configuration is incomplete.", {
      apiGatewayEndpoint,
      customerId,
      title,
      summary,
      caseReason
    });
    return;
  }

  try {
    const response = await fetch(apiGatewayEndpoint.createCase, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        customerId,
        title,
        summary,
        case_reason: caseReason,
        attributes: attributes
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to create case: ${response.statusText}`);
    }

    const responseData = await response.json();
    console.log("Amazon Connect case created successfully:", responseData);
    return responseData;
  } catch (error) {
    console.error("Error creating case:", error);
  }
};

export {
  handleAmazonConnectChatTransfer,
  handleAmazonConnectEmailContact,
  handleAmazonConnectCaseCreation,
  handleAmazonConnectSearchProfile
};
